import {
  GovernanceLeadershipAndOversightLabel,
  GovernanceLeadershipAndOversightsKey,
  PolicyAndManagementProcessesKey,
  PolicyAndManagementProcessesLabel
} from '../../../../components/Forms/Constants/ManagementAndProcessDisclosures/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';

/* eslint-disable max-len */
export const policyAndManagementProcessesTabQuestions = [
  {
    key: '1',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: PolicyAndManagementProcessesLabel.PAMP_HEADING_1
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_1,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },
          {
            fieldType: inputType.HEADING,
            heading: PolicyAndManagementProcessesLabel.PAMP_HEADING_2
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_2,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },

          {
            fieldType: inputType.HEADING,
            heading: PolicyAndManagementProcessesLabel.PAMP_HEADING_3
          },
          {
            fieldType: inputType.ADDMORE_TEXTAREA,
            formList: {
              name: 'webLink',
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_3
                  // options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'Whether the entity has translated the policy into procedures. (Yes/No)',
        field: [
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_4,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          }
        ]
      },
      {
        question:
          'Do the enlisted policies extend to your value chain partners? (Yes/No)',
        field: [
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_5,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          }
        ]
      },
      {
        question:
          'Name of the national and international codes/certifications/labels/ standards (e.g. Forest   Stewardship Council, Fairtrade, Rainforest Alliance, Trustea) standards (e.g. SA 8000, OHSAS, ISO, BIS) adopted by your entity and mapped to each principle.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_6,
            askAIkey: 'PMP_CODES_STANDARDS'
            // options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          }
        ]
      },
      {
        question:
          'Specific commitments, goals and targets set by the entity with defined timelines, if any.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_7,
            askAIkey: 'PMP_COMMITMENTS'
            // options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          }
        ]
      },
      {
        question:
          'Performance of the entity against the specific commitments, goals and targets along-with reasons in case the same are not met.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: PolicyAndManagementProcessesKey.PAMP_QUESTION_8,
            askAIkey: 'PMP_PERFORMANCE'
            // options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          }
        ]
      }
    ]
  }
];

export const governanceLeadershipAndOversightTabQuestions = [
  {
    key: '1',
    showIndex: false,
    items: [
      {
        question:
          '7. Statement by director responsible for the business responsibility report, highlighting ESG related challenges, targets and achievements (listed entity has flexibility regarding the placement of this disclosure)',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_1,
            askAIkey: 'GLO_DIRECTOR_STATEMENT'
          }
        ]
      },
      {
        question:
          '8. Details of the highest authority responsible for implementation and oversight of the Business Responsibility policy (ies).',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_2,
            askAIkey: 'GLO_AUTHORITY_DETAILS'
          }
        ]
      },
      {
        question:
          '9. Does the entity have a specified Committee of the Board / Director responsible for decision making on sustainability related issues? (Yes / No). If yes, provide details.',
        field: [
          {
            fieldType: inputType.RADIOGROUP_GLAO_QUESTION_3,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_3,
            options: ['Yes', 'No'],
            askAIkey: 'GLO_SUSTAINABILITY_COMMITTEE'
          }
        ]
      },
      {
        question: '10. Details of Review of NGRBCs by the Company',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_1
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_3
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_4,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_5,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_6,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_7,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_8,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_9,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_10,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_11,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_12,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_4
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_13,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_14,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_15,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_16,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_17,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_18,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_19,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_20,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_21,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_2
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_3
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_22,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_23,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_24,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_25,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_26,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_27,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_28,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_29,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_30,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9,
            options: ['Director', 'Committee of the Board', 'Other']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_4
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_31,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_32,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_33,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_34,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_35,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_36,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_37,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_38,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          },
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_39,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9,
            options: ['Annually', 'Half yearly', 'Quarterly', 'Other']
          }
        ]
      },
      {
        question:
          '11. Has the entity carried out independent assessment/ evaluation of the working of its policies by an external agency? (Yes/No).If yes, provide name of the agency',
        field: [
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_40,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_41,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_42,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_43,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_44,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_45,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_46,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_47,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8
          },
          {
            fieldType: inputType.CHECKBOX_GLAO_QUESTION_40_TO_48,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_48,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9
          }
        ]
      },
      {
        question:
          '12. If answer to question (1) above is “No” i.e. not all Principles are covered by a policy, reasons to be stated:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_5
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_49,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_6
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_50,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_7
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_51,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_8
          },
          {
            fieldType: inputType.CHECKBOXGROUP,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_52,
            options: ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9']
          },
          {
            fieldType: inputType.HEADING,
            heading: GovernanceLeadershipAndOversightLabel.GLAO_HEADING_9
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_53,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_1
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_54,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_2
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_55,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_3
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_56,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_4
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_57,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_5
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_58,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_6
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_59,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_7
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_60,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_8
          },
          {
            fieldType: inputType.TEXT,
            fieldName: GovernanceLeadershipAndOversightsKey.GLAO_QUESTION_61,
            fieldLabel: GovernanceLeadershipAndOversightLabel.GLAO_Label_9
          }
        ]
      }
    ]
  }
];
